import { render, staticRenderFns } from "./ViewMain.vue?vue&type=template&id=fcb139aa"
import script from "./ViewMain.vue?vue&type=script&lang=js"
export * from "./ViewMain.vue?vue&type=script&lang=js"
import style0 from "./ViewMain.vue?vue&type=style&index=0&id=fcb139aa&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports